import { ItemSummaryFieldEnum } from 'Common/FieldEnum';

export const MealTypeEnum = {
  Breakfast: 'breakfast',
  Lunch: 'lunch',
  Other: 'other',
  Supper: 'supper',
  All: 'all',
};

export const itemSummaryInitialValues = () => {
  return {
    [ItemSummaryFieldEnum.MealType]: MealTypeEnum.All,
    [ItemSummaryFieldEnum.To]: new Date().toLocaleDateString('en-US'),
    [ItemSummaryFieldEnum.From]: new Date().toLocaleDateString('en-US'),
    [ItemSummaryFieldEnum.Site]: 'ALL',
  };
};

export const MealTypeOptions = [
  { value: MealTypeEnum.Breakfast, label: 'Breakfast' },
  { value: MealTypeEnum.Lunch, label: 'Lunch' },
  { value: MealTypeEnum.Other, label: 'Other' },
  { value: MealTypeEnum.Supper, label: 'Supper' },
  { value: MealTypeEnum.All, label: 'All' },
];



// WEBPACK FOOTER //
// ./src/pages/itemsummary/helpers/ItemSummaryObjects.js